<template>
	<v-container class="d-flex flex-column align-start" pa-0 fluid fill-height>
		<FullHeader />
		<v-container fluid style="display:flex; flex-grow: 1;max-height: 100%;height: 200px;" class="pa-0">
			<EntryPoint />
		</v-container>
	</v-container>
</template>

<script>
import FullHeader from '../../Globals/Headers/FullHeader'
import EntryPoint from './EntryPoint.vue';

export default {
	name: 'FileManager',
	components: {
		FullHeader,
		EntryPoint
	}

}
</script>

<style>

</style>